import GetTickets from '@/graphql/Tickets/GetTickets.gql'
import GetTicket from '@/graphql/Tickets/GetTicket.gql'
import CreateTicket from '@/graphql/Tickets/CreateTicket.gql'
import GetTicketComments from '@/graphql/Tickets/GetTicketComments.gql'
import CreateTicketComment from '@/graphql/Tickets/CreateTicketComment.gql'
import CloseTicket from '@/graphql/Tickets/CloseTicket.gql'
import UpdateTicket from '@/graphql/Tickets/UpdateTicket.gql'
import GetTicketEvidence from '@/graphql/Tickets/GetTicketEvidence.gql'
import CreateTicketEvidence from '@/graphql/Tickets/CreateTicketEvidence.gql'
import { createProvider } from '../../vue-apollo'

const apollo = createProvider()

export default {
  async getTickets ({ dispatch }, { pageNumber = 1, perPage = 10, statusCode } = {}) {
    try {
      const response = await apollo.defaultClient.query({
        query: GetTickets,
        fetchPolicy: 'no-cache',
        variables: {
          pageNumber,
          perPage,
          statusCode
        }
      })
      return response.data.tickets
    } catch (err) {
      dispatch('showError', err)
    }
  },

  async getTicket ({ dispatch }, id) {
    try {
      const response = await apollo.defaultClient.query({
        query: GetTicket,
        fetchPolicy: 'no-cache',
        variables: {
          id
        }
      })
      return response.data.ticket
    } catch (err) {
      dispatch('showError', err)
    }
  },

  async createTicket ({ dispatch }, input) {
    try {
      const response = await apollo.defaultClient.mutate({
        mutation: CreateTicket,
        fetchPolicy: 'no-cache',
        variables: {
          input
        }
      })
      dispatch('addTemporalNotification', { type: 'success', message: `Tu ticket ${response.data.createTicket.folio} fue creado correctamente` })
      return response.data.createTicket
    } catch (err) {
      dispatch('showError', err)
      return null
    }
  },

  async getTicketComments ({ dispatch }, ticketId) {
    try {
      const response = await apollo.defaultClient.query({
        query: GetTicketComments,
        fetchPolicy: 'no-cache',
        variables: {
          ticketId
        }
      })
      return response.data.getTicketComments
    } catch (err) {
      dispatch('showError', err)
    }
  },

  async createTicketComment ({ dispatch }, { ticketId, text }) {
    try {
      const response = await apollo.defaultClient.mutate({
        mutation: CreateTicketComment,
        fetchPolicy: 'no-cache',
        variables: {
          ticketId,
          text
        }
      })
      return response.data.createTicketComment
    } catch (err) {
      dispatch('showError', err)
      return null
    }
  },

  async closeTicket ({ dispatch }, { ticketId }) {
    try {
      const response = await apollo.defaultClient.mutate({
        mutation: CloseTicket,
        fetchPolicy: 'no-cache',
        variables: {
          ticketId
        }
      })
      return response.data.closeTicket
    } catch (err) {
      dispatch('showError', err)
      return null
    }
  },

  async updateTicket ({ dispatch }, { ticketId, priorityCode, moduleCode, statusCode }) {
    try {
      const response = await apollo.defaultClient.mutate({
        mutation: UpdateTicket,
        fetchPolicy: 'no-cache',
        variables: {
          ticketId,
          priorityCode,
          moduleCode,
          statusCode
        }
      })
      dispatch('addTemporalNotification', { type: 'success', message: 'El ticket se ha actualizado correctamente' })
      return response.data.updateTicket
    } catch (err) {
      dispatch('showError', err)
      return null
    }
  },

  async getTicketEvidence ({ dispatch }, { ticketId }) {
    try {
      const response = await apollo.defaultClient.query({
        query: GetTicketEvidence,
        fetchPolicy: 'no-cache',
        variables: {
          ticketId
        }
      })
      return response.data.getTicketEvidence
    } catch (err) {
      dispatch('showError', err)
    }
  },

  async createTicketEvidence ({ dispatch }, { ticketId, fileBase64, fileName, contentType }) {
    try {
      const response = await apollo.defaultClient.mutate({
        mutation: CreateTicketEvidence,
        fetchPolicy: 'no-cache',
        variables: {
          ticketId,
          fileBase64,
          fileName,
          contentType
        }
      })
      return response.data.createTicketEvidence
    } catch (err) {
      dispatch('showError', err)
      return null
    }
  }
}
